module.exports = __webpack_public_path__ + "static/media/FixWhite.01c17ead.svg";